import {setToastr} from "../../containers/App/appSlice"
import {RootState} from "../../rootReducer"
import {useAppSelector, useAppDispatch} from "../../store"
import { Snackbar } from "@volvo/vcdk-react/Snackbar";
import { Divider } from "@volvo/vcdk-react/Divider";
import { SystemIcon } from "@volvo/vcdk-react/SystemIcon";

const AlertToastr = () => {
    const dispatch = useAppDispatch()
    setTimeout(
        () =>
            errorToastr.isActive &&
            dispatch(
                setToastr({
                    isActive: false,
                    message: "",
                    delay: 0,
                    title: "",
                    type: "",
                    description: "",
                }),
            ),
        3000,
    )
    const close = () => {
                 dispatch(
                setToastr({
                    isActive: false,
                    message: "",
                    delay: 0,
                    title: "",
                    type: "",
                    description: "",
                }))
    }
    const errorToastr = useAppSelector((state: RootState) => state.application.toastr)
    const styleDivider = {"--vcdk-divider-spacing": "0.2rem"} as React.CSSProperties
    const styleSnackbar = {"--vcdk-spacing-6": "0.8rem"} as React.CSSProperties
    return (
       <>
             <style>
                {`
                    vcdk-header-expressive.toastrBar::part(bar) {
                    padding: 0;
                    height: auto;
                    }
                `}
             </style>
            <Snackbar open={errorToastr.isActive} variant={errorToastr.type==='danger' ? 'error' : 'default'} position="top-right" themeId="volvo-dark" style={styleSnackbar}>
                <div style={{display:"flex", justifyContent:"space-between"}}>
                    <strong  style={errorToastr.type==='danger' ? {color: 'white'} : {}}  className="me-auto">{errorToastr.title}</strong>
                    <SystemIcon   size={24} icon="close" themeId="volvo-light" onClick={close} />
                </div>
                <Divider style={styleDivider} />
                <div style={{width: "20rem", wordBreak: "break-word",overflowWrap: "break-word", ...(errorToastr.type==='danger' ? {color: 'white'} : {})}}>
                    {`${errorToastr.message}${errorToastr.description&&errorToastr.description.length > 0 ? " - " : ""}${
                    errorToastr.description&&errorToastr.description.length > 0 ? errorToastr.description : ""
                    }`}
                </div>
            </Snackbar>
        </>
    )
}

export default AlertToastr
